//#region types
import { MonthInputProps, NumberInputProps } from "models/propTypes/wintFormPropsTypes";
import { TimeBalancesSectionProps } from "models/propTypes/wintSalaryPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import React from "react";
import { NumberInput, VerticalFormField } from "components/common/wintForms";
import MonthInput from "components/common/wintForms/formFields/monthInput";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

/**
 * Comp-time (Komp / TimeBalances) input section.
 *
 * A monthly deviation captured as a single signed number of hours: positive adds
 * to the comp bank, negative deducts. The value is saved to the deviation period's
 * scalar `value` field. Reuses the existing month picker. No comment field —
 * comments are only allowed for Compensation deviations (backend rule).
 */
const TimeBalancesSection: React.FC<TimeBalancesSectionProps> = (props) => {
  const { connect, readOnly } = props;

  return (
    <>
      <VerticalFormField<MonthInputProps>
        Component={MonthInput}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.Month)}
        {...connect("timeBalances.yearMonth")}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.SalaryDeviation.CompTimeMonthDescription
        )}
        showMainLabel
        disabled={readOnly}
      />
      <VerticalFormField<NumberInputProps>
        Component={NumberInput}
        {...connect("timeBalances.value")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CompTimeHours)}
        icon={IconDefinitionConstants.WClock2}
        suffix="h"
        decimalPoints={2}
        allowNegative
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.SalaryDeviation.CompTimeHoursDescription
        )}
        showMainLabel
        disabled={readOnly}
      />
    </>
  );
};

export default TimeBalancesSection;
